import React from 'react';
import { WorkingDaysSettingsSpa } from '@atlassian/jira-software-board-settings-working-days';

export const LazyWorkingDaysSettingsSpa = () => <WorkingDaysSettingsSpa />;

export default LazyWorkingDaysSettingsSpa;
